<template>
<v-container fluid>
  <v-form ref="form">
    <v-row dense>
      <v-col v-for="(field, i) in formCreate.status_finish.formulario.fields" :key="i" :cols="field.cols"  :offset="field.offset" :hidden="field.hidden">

          <v-text-field v-if="field.field == 'text' && !field.hidden"
              v-model="model[field.nameid]"
              :label="field.name"
              :type="field.type"
              :rules="(field.rules) ? fieldRequired : []"
              outlined
              dense/>

          <DatePicker v-else-if="field.field == 'textDatePicker' && !field.hidden" :itemAction="field" :on-success="actionFieldData"/>
          <SearchEmployee v-else-if="field.field == 'searchDataServer'"
            :itemAction="field"
            :on-success="actionFieldData"
            :setterModel="model[field.name.toLowerCase()]"
            :Selected="SelectedAction"/>

          <v-textarea v-else-if="field.field == 'textArea'"
              v-model="model[field.nameid]"
              :label="field.name"
              :name="field.dimens"
              :rules="(field.rules) ? fieldRequired : []"
              outlined
              dense>
          </v-textarea>
          <v-select v-else-if="field.field == 'select'"
              v-model="model[field.nameid]"
              :items="field.items"
              :label="field.name"
              :rules="(field.rules) ? fieldRequired : []"
              outlined
              dense>
          </v-select>

          <SelectedMain v-else-if="field.field == 'selectDataServer' && !field.hidden" :setterModel="model[field.nameid]" :itemAction="field" :on-success="actionFieldData" />
          <SelectedGroupMain v-else-if="field.field == 'selectGroupDataServer' && !field.hidden" :setterModel="model[field.nameid]" :itemAction="field" :on-success="actionFieldData" />

          <div v-else-if="field.field == 'radioButton'">
            <label class="text--black font-weight-bold font-weight-black">{{field.name}}</label>
            <v-radio-group
                :rules="(field.rules) ? fieldRequired : []"
                v-model="model[field.nameid]" row @change="RadioChange(field)"
                class="ma-0">
                <v-radio
                  v-for="value in field.items"
                  :key="value"
                  :label="value"
                  :value="value">
                </v-radio>
            </v-radio-group>
          </div>
          <v-row dense v-else-if="field.field == 'checkbox'">
              <v-checkbox
                v-model="model.selected"
                v-for="(value,i) in field.items" :key="i"
                :label="value"
                :value="value"
                @change="RadioChange(field)">
              </v-checkbox>
          </v-row>

          <v-row dense v-else-if="field.field == 'treevireDataServerDialog'">
            <v-dialog transition="dialog-bottom-transition" persistent max-width="500">
              <template v-slot:activator="{ on, attrs }">
                <v-flex sm12>
                  <v-text-field
                    v-bind="attrs" v-on="on"
                    v-model="model[field.viewname]"
                    :label="field.name"
                    :rules="(field.rules) ? fieldRequired : []"
                    outlined
                    readonly
                    dense/>
                </v-flex>
              </template>
              <template v-slot:default="dialog">
                <v-card>
                    <TreeView :itemAction="field" :on-success="actionFieldData" />
                  <v-card-actions class="justify-end">
                    <v-btn text @click="dialog.value = false">Close</v-btn>
                  </v-card-actions>
                </v-card>
              </template>
            </v-dialog>
          </v-row>

      </v-col>
      <v-col cols="12">
        <v-layout justify-end>
          <v-btn class="mr-3" color="red darken-1" depressed outlined @click="onCancel">Cerrar</v-btn>
          <v-btn class="mr-3" color="success darken-1" depressed outlined @click="sendForm(formCreate)" :disabled="disableBtn" :loading="disableBtn">
            {{formCreate.status_finish.nombre}}
          </v-btn>
        </v-layout>
      </v-col>
    </v-row>
  </v-form>
</v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import treeView from '@/components/fields/treeViewDepartaments'
import selectedMain from '@/components/fields/selectedMain'
import selectedGroupMain from '@/components/fields/selectedGroupMain'
import searchEmployee from '@/components/fields/searchEmployee'
import datePicker from '@/components/fields/DatePicker'
export default {
  props: ['formCreate', 'onSuccess', 'onCancel', 'model'],
  data: () => ({
    fieldRequired: [
      value => !!value || 'Campo Requerido.'
    ],
    disableBtn: false
  }),
  methods: {
    ...mapActions([]),
    ...mapMutations(['SET_LOADING_STATUS']),

    actionFieldData (obj) {
      this.model[obj.id] = (obj.data === undefined) ? null : obj.data

      if (obj.view) { this.model[obj.view] = obj.viewText }
    },
    RadioChange (field) {
      if (field.action) {
        this[field.action](field)
      }
    },
    SelectedAction (field) {
      if (field.action) {
        this[field.action](field)
      }
    },
    SelectedActionFuntion (field) {
      if (field.isHidden) {
        field.isHidden.map((item, i) => {
          this.formCreate.status_finish.formulario.fields.map((form, index) => {
            if (item === form.nameid) {
              form.url = `${form.url}/${this.model[form.nameid]}`
            }
          })
        })
      }
      this.ShowAndHeddenInput(field)
    },

    ShowAndHeddenInputEquipo (field) {
      if (field.isHidden) {
        field.isHidden.map((item, i) => {
          this.formCreate.status_finish.formulario.fields.map((form, index) => {
            if (item === form.nameid) {
              if (this.model[field.nameid] === 'Inventario') {
                if (form.nameid === 'inventario_id') {
                  form.hidden = false
                } else {
                  form.hidden = true
                }
              } else if (this.model[field.nameid] === 'No Inventario') {
                if (form.nameid === 'inventario_id') {
                  form.hidden = true
                } else {
                  form.hidden = false
                }
              }
              // form.hidden = !form.hidden
            }
          })
        })
      }
    },

    ShowAndHeddenInput (field) {
      if (field.isHidden) {
        field.isHidden.map((item, i) => {
          this.formCreate.status_finish.formulario.fields.map((form, index) => {
            if (item === form.nameid) {
              if (form.hidden && this.model[field.nameid] === 'Programado') {
                form.hidden = false
                this.model[form.nameid] = ''
              } else if (this.model[field.nameid] === 'No Programado') {
                form.hidden = true
              }
            }
          })
        })
      }
    },
    ShowAndHeddenSolicitante (field) {
      if (field.isHidden) {
        field.isHidden.map((item, i) => {
          this.formCreate.status_finish.formulario.fields.map((form, index) => {
            if (item === form.nameid) {
              if (this.model[field.nameid] === 'SI') {
                if (form.nameid === 'solicitante_id') {
                  form.hidden = false
                } else {
                  form.hidden = true
                }
              } else if (this.model[field.nameid] === 'NO') {
                if (form.nameid === 'solicitante_id') {
                  form.hidden = true
                } else {
                  form.hidden = false
                }
              }
              // this.model[form.nameid] = ''
            }
          })
        })
      }
    },

    sendForm (form) {
      if (this.$refs.form.validate()) {
        const item = this.validateComponents()
        if (item !== null) {
          this.$swal({
            type: 'error',
            icon: 'error',
            title: 'Advertencia!',
            text: ' Campo ' + item.name + ' no debe ser vacio!!'
          })
        } else {
          this.SET_LOADING_STATUS(true)
          this.onSuccess({
            descripcion: this.model,
            action: form.accion,
            status: form.estatus_final_id,
            actual: form.estatus_actual_id
          })
        }
      }
    },
    validateComponents () {
      let itemSelected = null
      this.formCreate.status_finish.formulario.fields.map(item => {
        if (item.rules) {
          if (!item.hidden) {
            if (!this.model[item.nameid]) {
              itemSelected = item
            } else if (this.model[item.nameid] === null) {
              itemSelected = item
            }
          }
        }
      })
      return itemSelected
    },
    closeDialog (dialog) {
      dialog.value = false
    }
  },
  computed: {
    ...mapGetters(['get_loading'])
  },
  components: {
    SelectedMain: selectedMain,
    SelectedGroupMain: selectedGroupMain,
    SearchEmployee: searchEmployee,
    DatePicker: datePicker,
    TreeView: treeView
  },
  watch: {
    get_loading (val) {
      this.disableBtn = val
    }
  }
}
</script>

<style>
</style>
